/// <amd-module name="VSS/Redux/Modules/Navigation/NavigationModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";
import { INavigationAwareState } from "./NavigationContracts";
import { navigationReducer } from "./NavigationReducer";
import { navigationSaga } from "./NavigationSaga";

export const NavigationModule: ISagaModule<INavigationAwareState> = {
    id: "navigation",
    reducerMap: {
        navigationState: navigationReducer
    },
    sagas: [navigationSaga]
};
